<template lang="pug">
.pb-4
  div(class="mt-10 md:mt-0 md:flex md:items-center md:justify-between")
    nav(class='sm:hidden')
      a.flex.items-center.text-sm.leading-5.font-medium.text-gray-500.transition.duration-150.ease-in-out(href='#' class='hover:text-gray-700', @click="backOnClick")
        svg.flex-shrink-0.-ml-1.mr-1.h-5.w-5.text-gray-400(viewbox='0 0 20 20' fill='currentColor')
          path(fill-rule='evenodd' d='M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z' clip-rule='evenodd')
        | {{ $t('common.back') }}
    nav.hidden.items-center.text-sm.leading-5.font-medium(class='sm:flex')
      template(v-for="breadcrumb, i in breadcrumbs")
        a.text-gray-500.transition.duration-150.ease-in-out(href='#' class='hover:text-gray-700', @click="$router.push({path: breadcrumb.path})") {{ $t(breadcrumb.title) }}
        svg.flex-shrink-0.mx-2.h-5.w-5.text-gray-400(viewbox='0 0 20 20' fill='currentColor' v-if="i != (breadcrumbs.length-1)")
          path(fill-rule='evenodd' d='M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z' clip-rule='evenodd')

      slot(name='breadcrumbs')
    div.text-right
      IdTW(v-if="id", :id="id")

  .mt-3(class='md:flex md:items-center md:justify-between')
    .flex-1.min-w-0
      .flex.item-center.align-baseline
        svg.h-6.w-6.mr-2.text-gray-400.stroke-current.stroke-2(v-if="icon" viewBox='0 0 24 24' fill='none')
          path(:d="icon")
        h2.text-xl.font-medium.leading-6.text-cool-gray-700(class='sm:text-xl sm:leading-6 sm:truncate')
          slot
</template>

<script>
import IdTW from '@/components/idtw.vue';

export default {
  components: {
    IdTW,
  },
  props: ['icon', 'id', 'breadcrumbs'],
  methods: {
    backOnClick() {
      if (this.breadcrumbs !== undefined) {
        this.$router.push({ path: this.breadcrumbs[0].path });
        return;
      }
      this.$router.go(-1);
    },
  },
};
</script>
